<div class="sso-container" *ngIf="loading">
  <div class="sso-card">
    <div class="sso-spinner"></div>
    <p class="sso-text">{{ loadingMessage }}</p>
  </div>
</div>

